module.exports = __webpack_public_path__ + "static/img/1011_small.243dc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1011_small.png
// module id = 0C3Q
// module chunks = 1